import request from './build'
import store from '~/store';

export default{

 getUrl(url, params){

     if(params !== undefined && params !== '' && params != null){
         if(url.indexOf("{") != -1 && params !== undefined && (params instanceof Object || params instanceof Array)){

             url=url.replace(/\{\w+\}/g, function(key){

                     if(key == undefined){
                         return "";
                     }
                     key = key.slice(1, -1)

                     return params[key];
                 }
             );
         }else{
             url = url+ '/'+ params
         }
     }
    
     url = url[0] === '/' ? url : ('/'+ url);
  return url;
 },

 /**
  * post请求
  * @param {*} url 
  * @param {*} params 
  */
 post(url, params) {

  //url = this.getUrl(url)
     //console.log(url)
    //name = '1212111aaa {bbb} ccc22222';
  //let params = {bbb:"9568"}

    /*return request({
      url,
      method: 'POST',
      params
    })*/
    url = url[0] === '/' ? url : ('/'+ url);
     return request({
         url: url,
         data: params,
         method: 'POST'
     });
  },
  
  /**
   * get请求
   * @param {*} url 
   * @param {*} params 
   */
  get(url, params ) {
      let parameter = ''
      if(!(params instanceof Object )){
          url = this.getUrl(url, params);
      }else{
          url = this.getUrl(url, '');
          parameter = params
      }

    
    return request({
      url,
      method: 'get',
        parameter
    })
  },
  /**
   * 同步请求
   * @param {*} url 
   * @param {*} params 
   */
  async  awaitGet(url, params){
    url = url[0] === '/' ? url : ('/'+ url);
    return await this.get(url, params );
  }
}



// WEBPACK FOOTER //
// ./src/api/myRequest.js